import { render } from "./HomeVue.vue?vue&type=template&id=07f55c70"
import script from "./HomeVue.vue?vue&type=script&lang=js"
export * from "./HomeVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__